import { render, staticRenderFns } from "./AdminFirst.vue?vue&type=template&id=18b004ea&scoped=true&"
import script from "./AdminFirst.vue?vue&type=script&lang=js&"
export * from "./AdminFirst.vue?vue&type=script&lang=js&"
import style0 from "./AdminFirst.vue?vue&type=style&index=0&id=18b004ea&prod&lang=less&"
import style1 from "./AdminFirst.vue?vue&type=style&index=1&id=18b004ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b004ea",
  null
  
)

export default component.exports